import React from 'react';
import useToggle from '@hooks/useToggle';
import { $panelApi } from '@stores/panelStores';
import ImgUpload from './img-upload.png';
import CategoryList from '../CategoryList';
import SubCategoryList from '../SubCategoryList';
import SceneList from '../SceneList';
import addScenes from '../actions/addScenes';
import { ScenesManagementModal } from '../ScenesManagementModal';

function CategoryBar() {
  const managementModal = useToggle(false);
  return (
    <div className="mt-10 flex h-160 select-none">
      <div className="mr-5 flex flex-1 flex-col">
        <CategoryList />
        <div className="flex flex-1 flex-col rounded bg-black-#28 p-10">
          <SubCategoryList />
          <SceneList />
        </div>
      </div>
      <div className="flex h-full w-90 flex-shrink-0  flex-col items-center justify-center">
        <div
          className="mb-5 flex h-25 w-full cursor-pointer items-center justify-center rounded bg-black-#28 px-10 text-white hover:bg-black-#34"
          onClick={() => {
            $panelApi.dismiss();
            managementModal.on();
          }}
        >
          场景管理
        </div>
        <div
          className="flex w-full grow cursor-pointer flex-col items-center justify-center rounded bg-black-#28 hover:bg-black-#34"
          onClick={() => addScenes()}
        >
          <img src={ImgUpload} className="mb-5 h-25 w-25" alt="" />
          <div>添加场景</div>
        </div>
      </div>
      {managementModal.isOn && (
        <ScenesManagementModal onRequestClose={() => managementModal.off()} />
      )}
    </div>
  );
}

export default CategoryBar;
